import React from "react";
import styles from './Footer.module.css';
import fb from '../../assets/home/facebook.png';
import linkdin from '../../assets/home/linkdin.png';
import insta from '../../assets/home/insta.png';
import { Link } from "react-router-dom";
import data from "../IndividualService/data";

const Footer = () => {

    // 🔥 Add your real URLs here
    const socialLinks = {
        facebook: "https://www.facebook.com/profile.php?id=61578533656429",
        linkedin: "https://www.linkedin.com/in/al-rimal-finance-consultancy-7054423ba/",
        instagram: "https://www.instagram.com/alrimaluae/"
    };

    return (
        <>
            <div className={styles.footerMain}>
                <div className="container">
                    <div className="row justify-content-between">

                        {/* 🔹 Company Info */}
                        <div className={`col-lg-4 col-md-6 ${styles.contain}`}>
                            <p className={styles.logo}>AL RIMAL</p>
                            <p className={styles.text}>AL BATEEN TOWER C6 BAINUNUNAH</p>
                            <p className={styles.text}>1st AND 2nd FLOOR STREET 34</p>
                            <p className={styles.text}>ADIB BUILDING</p>
                            <p className={styles.text}>ABU DHABI</p>
                            <p className={styles.text}>UAE</p>

                            {/* 🔥 Social Icons */}
                            <div className={styles.social_logo}>
                                <a href={socialLinks.facebook} target="_blank" rel="noreferrer">
                                    <img src={fb} alt="facebook" className={styles.img} />
                                </a>

                                <a href={socialLinks.linkedin} target="_blank" rel="noreferrer">
                                    <img src={linkdin} alt="linkedin" className={styles.img} />
                                </a>

                                <a href={socialLinks.instagram} target="_blank" rel="noreferrer">
                                    <img src={insta} alt="instagram" className={styles.img} />
                                </a>
                            </div>
                        </div>

                        {/* 🔹 Services */}
                        <div className={`col-lg-4 col-md-6 ${styles.contain}`}>
                            <p className={styles.head}>Services</p>

                            {data.map((service) => (
                                <Link
                                    key={service.id}
                                    to={`/individualService?id=${service.id}`}
                                    className={styles.serviceLink}
                                >
                                    {service.heading}
                                </Link>
                            ))}
                        </div>

                        {/* 🔹 Head Office */}
                        <div className={`col-lg-4 col-md-12 ${styles.contain}`}>
                            <p className={styles.head}>Contact Details</p>
                            <p className={styles.text}>info@alrimal.net</p>
                            <p className={styles.text}>Mobile : +971 524659070</p>
                            <p className={styles.text}>Mobile : +971 553029096</p>
                        </div>

                    </div>
                </div>
            </div>

            {/* 🔹 Bottom */}
            <div className={styles.footerBottom}>
                <p className={styles.bottom}>
                    Copyright © 2026. All rights reserved
                </p>
            </div>
        </>
    );
};

export default Footer;